import React from 'react'
import { Wrapper } from './styles'
import Overlay from '../Overlay'
import Info from '../../pages/Info'
import Blog from '../../pages/Blog'
import BlogArticle from '../../pages/BlogArticle'
import { Route, Link } from 'react-router-dom'
import TransitionGroup from 'react-transition-group/TransitionGroup'
import AnimatedSwitch from '../AnimatedSwitch'
import { styled } from 'styletron-react'
import { media, sizes } from '../../style'
import { border } from 'lostyle'
import ScrollLock from 'react-scrolllock'
import { H2 } from '../../components/Headings'
const NavLink = styled(Link, {
  textDecoration: 'none',
  color: '#333',
  marginBottom: sizes.spacing.s,
  fontWeight: 400,
  ':active': {
    color: '#777'
  },
  ...media('tabletLandscape', {
    fontSize: '4vw'
  })
})

const NavigationModal = styled('div', ({ $isOpen }) => ({
  position: 'fixed',
  zIndex: '999',
  top: '50px',
  right: '0',
  bottom: '0',
  left: '0',
  background: 'rgba(255,255,255,.8)',
  opacity: $isOpen ? 1 : 0,
  transition: 'opacity 300ms ease-in-out',
  ...(!$isOpen && { pointerEvents: 'none' })
}))
const NavigationList = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '32px',
  fontWeight: 700,
  height: '100%',
})

const NavButton = styled('button', {
  border: 0,
  paddingLeft: sizes.spacing.gutter.mobile,
  paddingRight: sizes.spacing.gutter.mobile,
  fontSize: '26px',
  color: '#333',
  appearance: 'none',
  background: 'rgba(0,0,0,0)',
  ':focus': {
    outline: 0
  },
  ':hover': {
    cursor: 'pointer',
  },
  ...media('tabletLandscape', {
    paddingLeft: sizes.spacing.gutter.desktop,
    paddingRight: sizes.spacing.gutter.desktop,
  }),
})

const CloseNavButtonWrapper = styled('div', {
  display: 'flex',
  marginLeft: 'auto',
  height: '50px',
  ...border({
    style: {
      left: 'solid'
    },
    width: {
      left: '1px',
    },
    color: {
      left: 'hsl(0,0%,95%)'
    }
  }),
})

const CloseNavButton = styled('button', {
  border: 0,
  color: '#333',
  fontSize: '30px',
  paddingLeft: sizes.spacing.gutter.mobile,
  paddingRight: sizes.spacing.gutter.mobile,
  appearance: 'none',
  background: 'rgba(0,0,0,0)',
  ':focus': {
    outline: 0
  },
  ':hover': {
    cursor: 'pointer',
  },
  ...media('tabletLandscape', {
    paddingLeft: sizes.spacing.gutter.desktop,
    paddingRight: sizes.spacing.gutter.desktop,
  }),
})

const NavBarWrapper = styled('div', {
  display: 'flex',
  height: '50px',
  ...border({
    style: {
      right: 'solid'
    },
    width: {
      right: '1px',
    },
    color: {
      right: 'hsl(0,0%,95%)'
    }
  }),
})

const NavBar = styled('div', {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1000,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '50px',
  backgroundColor: '#fff',
  ...border({
    style: {
      bottom: 'solid'
    },
    width: {
      bottom: '1px',
    },
    color: {
      bottom: 'hsl(0,0%,95%)'
    }
  })
})

const NavBarContent = styled('div', {
  width: sizes.page.maxWidth.desktop,
  display: 'flex',
  position: 'relative',
  marginLeft: 'auto',
  marginRight: 'auto',
})

class Layout extends React.Component {
  state = {
    showOverlay: true,
    navIsOpen: false,
  }
  hideOverlay = () => {
    this.setState({ showOverlay: false })
  }
  render() {
    return (
      <React.Fragment>
        {this.state.navIsOpen && <ScrollLock />}
        <NavBar>
          <NavBarContent>
            {this.state.navIsOpen
              ? (
                <CloseNavButtonWrapper>
                  <CloseNavButton onClick={() => this.setState({ navIsOpen: !this.state.navIsOpen })}>&#215;</CloseNavButton>
                </CloseNavButtonWrapper>
              ) : (
                <NavBarWrapper>
                  <NavButton onClick={() => this.setState({ navIsOpen: !this.state.navIsOpen })}>&#9776;</NavButton>
                </NavBarWrapper>
              )
            }
          </NavBarContent>
        </NavBar>
        <NavigationModal $isOpen={this.state.navIsOpen}>
          <NavigationList>
            <NavLink onClick={() => this.setState({ navIsOpen: !this.state.navIsOpen })} to="/">Home</NavLink>
            <NavLink onClick={() => this.setState({ navIsOpen: !this.state.navIsOpen })} to="/blog">Blog</NavLink>
          </NavigationList>
        </NavigationModal>
        <Wrapper>
          { this.state.showOverlay && <Overlay hideOverlay={this.hideOverlay} /> }
            <Route render={({ location }) => (
              <TransitionGroup component="main">
                <AnimatedSwitch key={location.pathname} location={location}>
                  <Route exact path="/" component={Info} />
                  <Route exact path="/blog" component={Blog} />
                  <Route exact path="/blog/:slug" render={routerProps => <BlogArticle {...routerProps} />} />
                  <Route path="*" render={routerProps => <H2 style={{ padding: '20px', textAlign: 'center' }}>404</H2>} />
                </AnimatedSwitch>
              </TransitionGroup>
            )} />
        </Wrapper>
      </React.Fragment>
    )
  }
}

export default Layout


// WEBPACK FOOTER //
// ./src/common/Layout/index.js